import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [wishlist, setWishlist] = useState([]); // product ids

  const loadWishlist = useCallback(async () => {
    try {
      const r = await api.get("/wishlist");
      setWishlist(r.data.map((p) => p.id));
    } catch { setWishlist([]); }
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
      await loadWishlist();
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, [loadWishlist]);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setUser(r.data.user); await loadWishlist();
    return r.data.user;
  };
  const register = async (name, email, password) => {
    const r = await api.post("/auth/register", { name, email, password });
    setUser(r.data.user); await loadWishlist();
    return r.data.user;
  };
  const completeGoogle = async (session_id) => {
    const r = await api.post("/auth/session", { session_id });
    setUser(r.data.user); await loadWishlist();
    return r.data.user;
  };
  const logout = async () => {
    await api.post("/auth/logout");
    setUser(null); setWishlist([]);
  };
  const loginWithGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const isWishlisted = (id) => wishlist.includes(id);
  const toggleWishlist = async (id) => {
    if (!user) return "unauth";
    if (wishlist.includes(id)) {
      setWishlist((w) => w.filter((x) => x !== id));
      await api.delete(`/wishlist/${id}`);
    } else {
      setWishlist((w) => [...w, id]);
      await api.post(`/wishlist/${id}`);
    }
    return "ok";
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, loginWithGoogle, completeGoogle, wishlist, isWishlisted, toggleWishlist }}>
      {children}
    </AuthContext.Provider>
  );
}
